module.exports = require("remark-github");


//////////////////
// WEBPACK FOOTER
// external "remark-github"
// module id = 70
// module chunks = 0 1 2 3 4 5 6 7 8 9 13